module.exports = __webpack_public_path__ + "static/purple-blotch-1f20f42203194c4fa38e91376ca4e0de.png";